<template>
  <div class="orient" :class="{'no_list': list.length === 0}">
    <p class="no_content" v-if="list.length === 0">暂无内容</p>
    <ul>
      <li class="pointer" v-for="(item, index) in list" :key="item.id" @click="toDetail(item.id)" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = ''">
        <h3>{{ item.title }}</h3>
        <p><img v-if="hoverIndex !== index" src="@/assets/clock-icon.png" /><img v-else src="@/assets/clock-h-icon.png" /><span>发布日期 {{ item.createdAt | dateFormat }}</span></p>
      </li>
    </ul>
    <el-pagination
      v-if="pages.total > 20"
      @current-change="handleCurrentChange"
      :current-page.sync="pages.pageNum"
      :page-size="pages.pageSize"
      layout="prev, pager, next, jumper"
      :total="pages.total" small>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'orient',
  components: {},
  data () {
    return {
      pages: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      list: [],
      hoverIndex: ''
    }
  },
  created () {
  },
  mounted () {
    this.loadChild()
  },
  computed: {
    params () {
      let param = { cls: 7 }
      param.pageNum = this.pages.pageNum
      param.pageSize = this.pages.pageSize
      return param
    }
  },
  methods: {
    loadChild () {
      this.$axios.child(this.params).then(res => {
        if (res) {
          this.list = res.data.data.list
          this.pages.total = res.data.data.total
        }
      })
    },
    handleCurrentChange (val) {
      this.pages.pageNum = val
      this.loadChild()
    },
    toDetail (itemId) {
      this.$router.push({
        path: '/orient/detail',
        query: {
          itemId: itemId
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .orient.no_list {height: 500px;}
  .orient {min-height: 500px;border: 1px solid #DCDFE6;padding: 0 15px;}
  .orient ul li {padding: 15px 0;border-bottom: 1px solid #DCDFE6;overflow: hidden;}
  .orient ul li:last-child {border-bottom: none;}
  .orient li h3 {font-size: 14px;font-weight: 600;color: #333333;line-height: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-bottom: 3px;float: left;width: 800px;}
  .orient li p {float: right;}
  .orient li p img {width: 12px;height: 12px;margin-right: 5px;}
  .orient li p span {font-size: 12px;font-weight: 400;color: #999999;line-height: 12px;}
  .orient li:hover h3 {color: #77B950;}
  .orient li:hover p span {color: #77B950;}
  .orient .el-pagination { text-align: right; }
</style>



// WEBPACK FOOTER //
// src/pages/orient/index.vue